import React from 'react'

export default function Badge(props) {
  return (
    <span className={"badge badge-"+props.type} {...props}>
      {props.children}
    </span>
  )
}